import React from 'react';
import { Icon } from '@rsuite/icons';
import DashboardIcon from '@rsuite/icons/legacy/Dashboard';
import MediaIcon from '@rsuite/icons/Media';
import ImageIcon from '@rsuite/icons/Image';
import { GiAchievement } from 'react-icons/gi';
import { BsCalendarEvent } from 'react-icons/bs';
import { RiSlideshow4Line } from 'react-icons/ri';
import { IoNewspaperOutline } from 'react-icons/io5';
import { FiUsers } from 'react-icons/fi';
import { FaFile, FaUserTie, FaHandsHelping } from 'react-icons/fa';

export const getNavLinks = (role) => {
  const links = [
    {
      name: 'Dashboard',
      path: '/',
      eventKey: '1',
      icon: <DashboardIcon />,
      type: 'normal',
    },
    {
      name: 'Slideshow',
      path: '/slideshow',
      eventKey: '2',
      icon: <Icon as={RiSlideshow4Line} stroke="#fff" style={{ stroke: '#fff' }} />,
      type: 'normal',
    },
    {
      name: 'Achievements',
      path: '/achievements',
      eventKey: '3',
      icon: <Icon as={GiAchievement} stroke="#fff" style={{ stroke: '#fff' }} />,
      type: 'normal',
    },
    {
      name: 'Stories',
      path: '/stories',
      eventKey: '4',
      icon: <ImageIcon />,
      type: 'normal',
    },
    {
      name: 'News',
      path: '/news',
      eventKey: '5',
      icon: <Icon as={IoNewspaperOutline} stroke="#fff" style={{ stroke: '#fff' }} />,
      type: 'normal',
    },
    {
      name: 'History / Milestone',
      path: '/milestone',
      eventKey: '6',
      icon: <Icon as={BsCalendarEvent} stroke="#fff" style={{ stroke: '#fff' }} />,
      type: 'normal',
    },
    {
      name: 'Gallery',
      eventKey: '7',
      path: '',
      icon: <Icon as={MediaIcon} stroke="#fff" style={{ stroke: '#fff' }} />,
      type: 'menu',
      items: [
        { name: 'Photos', eventKey: '7-1', path: '/photos', icon: '' },
        { name: 'Videos', eventKey: '7-2', path: '/videos', icon: '' },
      ],
    },
    {
      name: 'Donors & Supporters',
      eventKey: '8',
      path: '/donors',
      icon: <Icon as={FaHandsHelping} stroke="#fff" style={{ stroke: '#fff' }} />,
      type: 'normal',
    },
    {
      name: 'Career Opportunities',
      eventKey: '9',
      path: '',
      icon: <Icon as={FaUserTie} stroke="#fff" style={{ stroke: '#fff' }} />,
      type: 'menu',
      items: [
        { name: 'Vacancies', eventKey: '9-1', path: '/jobs', icon: '' },
        { name: 'Applications', eventKey: '9-2', path: '/applications', icon: '' },
      ],
    },
    {
      name: 'Procurement',
      eventKey: '10',
      path: '',
      icon: <Icon as={FaFile} stroke="#fff" style={{ stroke: '#fff' }} />,
      type: 'menu',
      items: [
        { name: 'RFPs & RFQs', eventKey: '10-1', path: '/rfp', icon: '' },
      ],
    },
    {
      name: 'Users',
      eventKey: '11',
      path: '/users',
      type: 'normal',
      icon: <Icon as={FiUsers} stroke="#fff" style={{ stroke: '#fff' }} />,
    },
  ];

  if (role === 'Admin') return links;
  if (role === 'HR') {
    return links.filter((item) => ['Career Opportunities', 'Dashboard'].includes(item.name));
  }
  if (role === 'Logistics') {
    return links.filter((item) => ['Procurement', 'Dashboard'].includes(item.name));
  }
  if (role === 'Moderator') {
    return links.filter((item) => !['Career Opportunities', 'Users', 'Procurement'].includes(item.name));
  }
  return [];
};
